import router from '../../router'
import NavigationBar from '../../components/navigation-bar/NavigationBar'
import Loader from '../../components/loader/Loader'
import moment from 'moment'
import { ScreenLoader } from '../../utils/loading.util'
import { LocationService, LocationDropdown, Location } from '../../services/location.service'
import { GroupService, GroupDropdown, Group } from '../../services/group.service'
import {DockStatusService, DoorPositionEnum, LevelerPositionEnum} from '../../services/dock-status.service'
import InputDropdown from '../../components/input-dropdown/InputDropdown'
import InputCheckbox from '../../components/input-checkbox/InputCheckbox'
import InputDatePicker from '../../components/input-date-picker/InputDatePicker'
import { TimeSlotUtil } from '../../utils/timeslot.util'
import { Constants } from '../../constants'
import {BookingService} from "@/services/booking.service";
import {CookieService} from "@/services/cookie.service";
import InputButton from "@/components/input-button/InputButton";
import Card from '@/components/card/Card'

export default {
    name: 'Docks',
    components: {
        NavigationBar,
        Loader,
        InputDropdown,
        InputButton,
        InputCheckbox,
        InputDatePicker,
        Card
    },

    data() {
        return {
            selectedDate: new Date(),
            locations: [],
            location: new Location(),
            dropdownLocations: [],
            groups: [],
            group: new Group(),
            dropdownGroups: [],
            groupBookings: [],
            sortedSpots: undefined,
            screenLoader: new ScreenLoader(),
            autoRefresh: true,
            timeSlots: [],
            currentTime: '',
            groupId: undefined,
            locationId: undefined,
            spotStatus: [],
            dockIntegration: false,
            doorPositionMap: new Map([
                [1, DoorPositionEnum.OPEN],
                [2, DoorPositionEnum.CLOSED]
            ]),
            levelerPositionMap: new Map([
                [1, LevelerPositionEnum.RETRACTED],
                [2, LevelerPositionEnum.DOWN],
                [3, LevelerPositionEnum.NOT_EQUIPED]
            ]),
            updatedSpotBookings: [],
            preference: {},
            cookieName: "docks",
            showLegend: false
        }
    },

    async mounted() {
        if (this.$route.query.date) {
            this.selectedDate = new Date(this.$route.query.date)
        }
        this.dockIntegration = process.env.VUE_APP_DOCK_INTEGRATION_PRESENT === 'true'

        this.preference = CookieService.getCookie(this.cookieName)

        this.locationId = this.preference?.location ?? this.$route.query.locationid
        this.groupId = this.preference?.group ?? this.$route.query.groupid

        const cookieAutoRefresh =  this.preference ? +this.preference?.autoRefresh === 1 : undefined

        this.autoRefresh = cookieAutoRefresh ?? this.autoRefresh
        this.toggleAutoRefreshTimer()
        await this.getLocations()
    },

    beforeDestroy() {
        clearInterval(this.timer)
    },



    methods: {
        async reload() {
            if (this.groups.length > 0) {
                await this.getGroupBookings()
            } else {
                await this.getLocations()
            }
        },

        getDockStatus: function(id) {
            const dockStatus = this.spotStatus?.find((spot) => spot.spotId === id)
            const occupied = dockStatus?.data !== undefined ? dockStatus.data.occupied == true : false
            const doorPosition = this.doorPositionMap.get(dockStatus?.data?.doorPosition)
            const levelerPosition = this.levelerPositionMap.get(dockStatus?.data?.levelerPosition)
            if (occupied) {
                switch (doorPosition) {
                    case DoorPositionEnum.OPEN:
                        switch (levelerPosition) {
                            case LevelerPositionEnum.DOWN:
                                return require("@/assets/icons/Unloading_blue.png")
                            case LevelerPositionEnum.RETRACTED:
                                return require("@/assets/icons/OnDockDooropen_blue.png")
                        }
                        break;
                    case DoorPositionEnum.CLOSED:
                        switch (levelerPosition) {
                            case LevelerPositionEnum.DOWN:
                                break; // the leveler cannot be down when the door is closed
                            case LevelerPositionEnum.RETRACTED:
                                return require("@/assets/icons/DooropenLevelerup_blue.png") // with truck?
                        }
                        break;
                }
            } else {
                switch (doorPosition) {
                    case DoorPositionEnum.OPEN:
                        switch (levelerPosition) {
                            case LevelerPositionEnum.DOWN:
                                return require("@/assets/icons/LevelerdownNotruck_blue.png")
                            case LevelerPositionEnum.RETRACTED:
                                return require("@/assets/icons/DooropenLevelerup_blue.png")
                        }
                        break;
                    case DoorPositionEnum.CLOSED:
                        switch (levelerPosition) {
                            case LevelerPositionEnum.DOWN:
                                break; // the leveler cannot be down when the door is closed
                            case LevelerPositionEnum.RETRACTED:
                                return require("@/assets/icons/Closeddoor_blue.png")
                        }
                        break;
                }
            }
        },

        isOnDock: function (id) {
            const dockStatus = this.spotStatus ? this.spotStatus.find((spot) => spot.spotId === id) : undefined
            return dockStatus?.data?.occupied == true
        },

        isExpected: function(id){
            const spot = this.sortedSpots.find(spot => spot.id === id)
            const dockStatus = this?.spotStatus ? this.spotStatus.find((spot) => spot.spotId === id) : undefined
            if (dockStatus) {
                let bookingId = spot.booking?.id
                return (spot.active && spot.booking && dockStatus.data.occupied === false && dockStatus.expectedBooking === bookingId)
            }
            return false
        },

        isLeaving: function (id){
            const spot = this.updatedSpotBookings.find(spot => spot.id === id)
            const dockStatus = this?.spotStatus ? this.spotStatus.find((spot) => spot.spotId === id): undefined
            if (dockStatus) {
                if (spot.booking != undefined && spot.booking.id === dockStatus.expectedBooking) {
                    return spot.booking.dockDepartureDate != undefined && spot.booking.dockArrivalDate != undefined
                        && spot.booking.vehicleArrivalDate != undefined && spot.booking.vehicleDepartureDate == undefined
                }
            }
            return false
        },

        getLocations: async function() {
            this.screenLoader.start(['locations'])
            this.isLocationsLoading = true

            try {
                const locations = await LocationService.getLocations()
                await this.handleLocationsResponse(locations)
            } catch (error) {
                this.screenLoader.stopWithError(error, ['locations'])
            }
        },

        getLocation: async function() {
            try {
                const location = await LocationService.getLocation(this.location.id)
                await this.handleLocationResponse(location)
            }catch(error) {
                this.screenLoader.stopWithError(error)
            }
        },

        getGroupBookings: async function() {
            this.screenLoader.start()
            try {
                this.spotStatus = this.dockIntegration ? await DockStatusService.getDockStatus(this.location.id) : []
                let groupBookings = await GroupService.getGroupBookings(this.group.id, this.selectedDate, this.location)
                await this.handleGroupBookingResponse(groupBookings)
            }catch(error) {
                this.screenLoader.stopWithError(error)
            }
        },

        async handleLocationsResponse(locations) {
            this.locations = locations.map(o => new Location(o))
            this.dropdownLocations = locations.map(o => new LocationDropdown(o))

            const locationId = this.locationId ? this.locationId : this.dropdownLocations[0].id
            await this.updateLocation(locationId)
        },

        async handleLocationResponse(location) {
            this.timeSlots = []
            this.location = location
            const startTime = TimeSlotUtil.getTimeSlotTime(location.timeSlotStartTime)
            const endTime = TimeSlotUtil.getTimeSlotTime(location.timeSlotEndTime)

            this.timeSlots = TimeSlotUtil.createTimeSlots(startTime, endTime, 30, true)

            const lastTimeSlot = this.timeSlots[this.timeSlots.length - 1]
            if (lastTimeSlot.hours == "00") {
                lastTimeSlot.hours = "24"
                lastTimeSlot.displayedHours = "24"
            }

            const groupId = this.groupId ? this.groupId : this.dropdownGroups[0].id
            await this.updateGroup(groupId)
        },

        async updateBookings(sortedSpots) {
            return await Promise.all(sortedSpots.map(async (spot) => {
                const bookingId = spot.booking?.id
                if (bookingId != undefined) {
                    await BookingService.getBooking(bookingId).then((b) => {
                        spot.booking = b
                    })
                }
                return spot
            }))
        },

        async handleGroupBookingResponse(groupBookings) {
            this.groupBookings = new Group(groupBookings)
            this.sortedSpots = this.groupBookings.getSortedSpots()
            this.updatedSpotBookings = await this.updateBookings(this.sortedSpots)
            const start = moment(this.selectedDate).toISOString()
            if (start != this.$route.query.date || this.location.id != this.$route.query.locationid || this.group.id != this.$route.query.groupid) {
                router.push(`/docks?locationid=${this.location.id}&groupid=${this.group.id}&date=${start}`)
            }

            this.locationId = undefined
            this.groupId = undefined
            this.screenLoader.stop()
        },

        async updateSelectedDate(date) {
            if (this.selectedDate != date) {
                this.selectedDate = date
                await this.getGroupBookings()
            }
        },

        async updateLocation(id) {
            this.location = this.locations.filter(location => location.id == id)[0]
            this.groups = this.location.groups.map(o => new Group(o))
            this.dropdownGroups = this.location.groups.map(o => new GroupDropdown(o))
            this.setPreference()
            await this.getLocation()
        },

        async updateGroup(id) {
            this.group = this.groups.find(group => group.id === id)
            this.setPreference()
            await this.getGroupBookings()
        },

        toggleAutoRefresh() {
            this.autoRefresh = !this.autoRefresh
            this.setPreference()
            this.toggleAutoRefreshTimer()
        },

        toggleAutoRefreshTimer() {
            if (this.autoRefresh) {
                this.timer = setInterval(this.getGroupBookings, Constants.DOCKS_AUTO_REFRESH)
            } else {
                clearInterval(this.timer)
            }
        },

        openBooking(spot) {
            if (spot.booking == undefined && spot.nextBooking == undefined) {
                return
            } else if (spot.booking != undefined) {
                router.push(`/booking/${spot.booking.id}`)
            } else {
                router.push(`/booking/${spot.nextBooking.id}`)
            }
        },

        setPreference () {
            const cookie = {
                "location": this.location.id,
                "group": this.group.id,
                "autoRefresh": this.autoRefresh === true ? "1" : "0"
            }
            CookieService.storeCookie(this.cookieName, cookie, 365)
        },

        showLegendPopup () {
            this.showLegend = !this.showLegend
        }

    }
}
